import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchGet, fetchPost, objectify } from '../utils';

export const search = (query) => {
  const { InvoiceNumber, SalesEntity, Page, filters, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchPost(
    `SalesInvoiceEnquiry/Entity/${SalesEntity}/SalesInvoice/${InvoiceNumber}/PickSlipsByProduct`,
    filters,
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then((result) => {
      return (result && result.PickSlipsByProducts) ? {
        records: result.PickSlipsByProducts.map((val) => ({ ...objectify(val) })),
        nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
        currPage: result.BatchInformation && result.BatchInformation.BatchPage,
      } : null;
    });
};

export const fetch = async (query: { SalesEntity: string; Invoice: string; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { SalesEntity, Invoice, Page, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchGet(
    `SalesInvoiceEnquiry/Entity/${SalesEntity}/SalesInvoice/${Invoice}/PickSlipsByDespatch`,
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        PickSlipsByDespatchs: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.PickSlipsByDespatchs) {

            return {
              records: result.PickSlipsByDespatchs.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
